import { PlayCircleOutlineOutlined } from '@mui/icons-material';
import { Divider } from '@mui/material';
import {
  type GuidedTourRegistryItem,
  PrimaryNavigationMenu,
  PrimaryNavigationMenuItem,
} from 'components/ui';
import { FIRM_PRIMARY_NAVIGATION_TEST_IDS } from 'layouts/FirmBaseLayout/PrimaryNavigation/PrimaryNavigation.testIds';

interface ProductToursMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onTourSelect: (tourId: string) => void;
  tours: GuidedTourRegistryItem[];
  zoomLevel: number;
}

const ProductToursMenu = ({ anchorEl, onClose, onTourSelect, tours, zoomLevel }: ProductToursMenuProps) => {
  const recommendedTours = tours.filter(tour => tour.isRecommended);
  const otherTours = tours.filter(tour => !recommendedTours.some(
    recommendedTour => recommendedTour.definition.id === tour.definition.id
  ));

  const renderTourItem = (tour: GuidedTourRegistryItem, prefix: string) => (
    <PrimaryNavigationMenuItem
      key={`${prefix}-${tour.definition.id}`}
      icon={<PlayCircleOutlineOutlined fontSize="inherit" />}
      onClick={() => onTourSelect(tour.definition.id)}>
      {tour.definition.title}
    </PrimaryNavigationMenuItem>
  );

  return (
    <PrimaryNavigationMenu
      anchorEl={anchorEl}
      data-testid={FIRM_PRIMARY_NAVIGATION_TEST_IDS.productToursMenu}
      menuMinWidth={240}
      onClose={onClose}
      open={Boolean(anchorEl)}
      zoomLevel={zoomLevel}
      transformOrigin={{ horizontal: 'left', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
      {recommendedTours.length > 0 && (
        <PrimaryNavigationMenuItem disabled isHeader>
          Recommended next
        </PrimaryNavigationMenuItem>
      )}
      {recommendedTours.map(tour => renderTourItem(tour, 'recommended'))}
      {recommendedTours.length > 0 && otherTours.length > 0 && <Divider key="product-tours-divider" />}
      {otherTours.length > 0 && (
        <PrimaryNavigationMenuItem disabled isHeader>
          All tours
        </PrimaryNavigationMenuItem>
      )}
      {otherTours.map(tour => renderTourItem(tour, 'all'))}
      {tours.length === 0 && (
        <PrimaryNavigationMenuItem disabled tone="muted">
          No tours available for this page
        </PrimaryNavigationMenuItem>
      )}
    </PrimaryNavigationMenu>
  );
};

export default ProductToursMenu;
